import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../wayfinder'
/**
* @see \App\Http\Controllers\CaddyDomainCheckController::__invoke
* @see app/Http/Controllers/CaddyDomainCheckController.php:21
* @route 'https://proexpert.app/caddy-domain-check'
*/
export const caddyDomainCheck = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: caddyDomainCheck.url(options),
    method: 'get',
})

caddyDomainCheck.definition = {
    methods: ["get","head"],
    url: 'https://proexpert.app/caddy-domain-check',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CaddyDomainCheckController::__invoke
* @see app/Http/Controllers/CaddyDomainCheckController.php:21
* @route 'https://proexpert.app/caddy-domain-check'
*/
caddyDomainCheck.url = (options?: RouteQueryOptions) => {
    return caddyDomainCheck.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CaddyDomainCheckController::__invoke
* @see app/Http/Controllers/CaddyDomainCheckController.php:21
* @route 'https://proexpert.app/caddy-domain-check'
*/
caddyDomainCheck.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: caddyDomainCheck.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CaddyDomainCheckController::__invoke
* @see app/Http/Controllers/CaddyDomainCheckController.php:21
* @route 'https://proexpert.app/caddy-domain-check'
*/
caddyDomainCheck.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: caddyDomainCheck.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CaddyDomainCheckController::__invoke
* @see app/Http/Controllers/CaddyDomainCheckController.php:21
* @route 'https://proexpert.app/caddy-domain-check'
*/
const caddyDomainCheckForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: caddyDomainCheck.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CaddyDomainCheckController::__invoke
* @see app/Http/Controllers/CaddyDomainCheckController.php:21
* @route 'https://proexpert.app/caddy-domain-check'
*/
caddyDomainCheckForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: caddyDomainCheck.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CaddyDomainCheckController::__invoke
* @see app/Http/Controllers/CaddyDomainCheckController.php:21
* @route 'https://proexpert.app/caddy-domain-check'
*/
caddyDomainCheckForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: caddyDomainCheck.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

caddyDomainCheck.form = caddyDomainCheckForm

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:12
* @route 'https://proexpert.app'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: 'https://proexpert.app',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:12
* @route 'https://proexpert.app'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:12
* @route 'https://proexpert.app'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:12
* @route 'https://proexpert.app'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:12
* @route 'https://proexpert.app'
*/
const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:12
* @route 'https://proexpert.app'
*/
homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HomeController::__invoke
* @see app/Http/Controllers/HomeController.php:12
* @route 'https://proexpert.app'
*/
homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

home.form = homeForm

/**
* @see \App\Http\Controllers\VoiceCreationController::__invoke
* @see app/Http/Controllers/VoiceCreationController.php:12
* @route 'https://proexpert.app/create-with-voice'
*/
export const voiceCreate = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: voiceCreate.url(options),
    method: 'get',
})

voiceCreate.definition = {
    methods: ["get","head"],
    url: 'https://proexpert.app/create-with-voice',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\VoiceCreationController::__invoke
* @see app/Http/Controllers/VoiceCreationController.php:12
* @route 'https://proexpert.app/create-with-voice'
*/
voiceCreate.url = (options?: RouteQueryOptions) => {
    return voiceCreate.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\VoiceCreationController::__invoke
* @see app/Http/Controllers/VoiceCreationController.php:12
* @route 'https://proexpert.app/create-with-voice'
*/
voiceCreate.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: voiceCreate.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoiceCreationController::__invoke
* @see app/Http/Controllers/VoiceCreationController.php:12
* @route 'https://proexpert.app/create-with-voice'
*/
voiceCreate.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: voiceCreate.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\VoiceCreationController::__invoke
* @see app/Http/Controllers/VoiceCreationController.php:12
* @route 'https://proexpert.app/create-with-voice'
*/
const voiceCreateForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: voiceCreate.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoiceCreationController::__invoke
* @see app/Http/Controllers/VoiceCreationController.php:12
* @route 'https://proexpert.app/create-with-voice'
*/
voiceCreateForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: voiceCreate.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\VoiceCreationController::__invoke
* @see app/Http/Controllers/VoiceCreationController.php:12
* @route 'https://proexpert.app/create-with-voice'
*/
voiceCreateForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: voiceCreate.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

voiceCreate.form = voiceCreateForm

/**
* @see \App\Http\Controllers\DashboardSignInRedirectController::__invoke
* @see app/Http/Controllers/DashboardSignInRedirectController.php:9
* @route 'https://proexpert.app/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

register.definition = {
    methods: ["get","head"],
    url: 'https://proexpert.app/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DashboardSignInRedirectController::__invoke
* @see app/Http/Controllers/DashboardSignInRedirectController.php:9
* @route 'https://proexpert.app/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DashboardSignInRedirectController::__invoke
* @see app/Http/Controllers/DashboardSignInRedirectController.php:9
* @route 'https://proexpert.app/register'
*/
register.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DashboardSignInRedirectController::__invoke
* @see app/Http/Controllers/DashboardSignInRedirectController.php:9
* @route 'https://proexpert.app/register'
*/
register.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: register.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\DashboardSignInRedirectController::__invoke
* @see app/Http/Controllers/DashboardSignInRedirectController.php:9
* @route 'https://proexpert.app/register'
*/
const registerForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DashboardSignInRedirectController::__invoke
* @see app/Http/Controllers/DashboardSignInRedirectController.php:9
* @route 'https://proexpert.app/register'
*/
registerForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DashboardSignInRedirectController::__invoke
* @see app/Http/Controllers/DashboardSignInRedirectController.php:9
* @route 'https://proexpert.app/register'
*/
registerForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

register.form = registerForm

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/about'
*/
export const about = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(options),
    method: 'get',
})

about.definition = {
    methods: ["get","head"],
    url: 'https://proexpert.app/about',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/about'
*/
about.url = (options?: RouteQueryOptions) => {
    return about.definition.url + queryParams(options)
}

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/about'
*/
about.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(options),
    method: 'get',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/about'
*/
about.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: about.url(options),
    method: 'head',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/about'
*/
const aboutForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: about.url(options),
    method: 'get',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/about'
*/
aboutForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: about.url(options),
    method: 'get',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/about'
*/
aboutForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: about.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

about.form = aboutForm

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/contact'
*/
export const contact = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

contact.definition = {
    methods: ["get","head"],
    url: 'https://proexpert.app/contact',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/contact'
*/
contact.url = (options?: RouteQueryOptions) => {
    return contact.definition.url + queryParams(options)
}

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/contact'
*/
contact.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/contact'
*/
contact.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: contact.url(options),
    method: 'head',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/contact'
*/
const contactForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url(options),
    method: 'get',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/contact'
*/
contactForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url(options),
    method: 'get',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/contact'
*/
contactForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contact.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

contact.form = contactForm

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/dashboard'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: 'https://proexpert.app/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/dashboard'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/dashboard'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/dashboard'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/dashboard'
*/
const dashboardForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/dashboard'
*/
dashboardForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \Inertia\Controller::__invoke
* @see vendor/inertiajs/inertia-laravel/src/Controller.php:13
* @route 'https://proexpert.app/dashboard'
*/
dashboardForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

dashboard.form = dashboardForm

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

login.form = loginForm

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

logout.form = logoutForm
